import React from 'react';
import { BodyText } from 'shared-portal-component';
import '@/components/atoms/AuthBodyText/AuthBodyText.scss';

interface AuthBodyTextProps {
    text?: string;
    children?: React.ReactNode;}

const AuthBodyText: React.FC<AuthBodyTextProps> = ({text, children}) => (
    <BodyText text={text} className="body-text-auth">
        {children}
    </BodyText>
);

export default AuthBodyText;
